import Swiper from 'swiper/bundle';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import LocomotiveScroll from 'locomotive-scroll';

gsap.registerPlugin(ScrollTrigger);

const pages = {
    init() {
        const video = document.getElementById('videoConcept');
        const playBtn = document.getElementById('playBtn');
        const pauseBtn = document.getElementById('pauseBtn');
        const fullscreenBtn = document.getElementById('fullscreenBtn');
        const videoContainer = video ? video.closest('.video-container') : null;

        if (video && playBtn && pauseBtn && fullscreenBtn && videoContainer) {
            video.addEventListener('contextmenu', (e) => e.preventDefault());

            playBtn.addEventListener('click', () => {
                video.play();
            });

            pauseBtn.addEventListener('click', () => {
                video.pause();
            });

            fullscreenBtn.addEventListener('click', () => {
                if (document.fullscreenElement) {
                    document.exitFullscreen();
                    return;
                }

                if (videoContainer.requestFullscreen) {
                    videoContainer.requestFullscreen();
                } else if (videoContainer.webkitRequestFullscreen) {
                    videoContainer.webkitRequestFullscreen();
                } else if (videoContainer.msRequestFullscreen) {
                    videoContainer.msRequestFullscreen();
                }
            });

            video.addEventListener('play', () => {
                playBtn.style.display = 'none';
                videoContainer.classList.add('is-playing');
            });

            video.addEventListener('pause', () => {
                if (!video.ended) {
                    playBtn.style.display = 'flex';
                }
                videoContainer.classList.remove('is-playing');
            });

            video.addEventListener('ended', () => {
                playBtn.style.display = 'flex';
                videoContainer.classList.remove('is-playing');
            });

            document.addEventListener('fullscreenchange', () => {
                const icon = fullscreenBtn.querySelector('i');
                if (!icon) return;

                if (document.fullscreenElement) {
                    icon.className = 'fa-solid fa-compress';
                    fullscreenBtn.setAttribute('aria-label', 'Quitter le plein écran');
                } else {
                    icon.className = 'fa-solid fa-expand';
                    fullscreenBtn.setAttribute('aria-label', 'Afficher en plein écran');
                }
            });
        }
    },
};

export default pages;